/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Deeply merges properties of source objects into a target object.
 * Arrays are concatenated, not merged by index.
 * Primitives and non-object values are overwritten.
 *
 * @param {object} target The object to merge properties into.
 * @param {...object} sources The source objects whose properties will be merged.
 * @returns {object} The target object with merged properties.
 */
function deepmerge(target, ...sources) {
  if (!target || typeof target !== 'object') {
    throw new Error('Deepmerge target must be an object.');
  }

  // Loop through each source object provided
  for (const source of sources) {
    // Skip if the source is not an object or is null
    if (!source || typeof source !== 'object') {
      continue;
    }

    // Iterate over the keys of the current source object
    for (const key in source) {
      // Ensure the key is a direct property of the source object (not inherited)
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const sourceValue = source[key];
        const targetValue = target[key];

        // Check if both source and target values are objects (and not arrays or null)
        if (
          typeof sourceValue === 'object' &&
          sourceValue !== null &&
          typeof targetValue === 'object' &&
          targetValue !== null &&
          !Array.isArray(sourceValue) &&
          !Array.isArray(targetValue)
        ) {
          // Recursively merge if both are non-array objects
          target[key] = deepmerge(targetValue, sourceValue);
        } else if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
          // Concatenate arrays
          target[key] = targetValue.concat(sourceValue);
        } else {
          // For primitives, non-object values, or when types don't match (e.g., object merging with a primitive)
          // overwrite the target value with the source value.
          target[key] = sourceValue;
        }
      }
    }
  }

  return target;
}

window.Shopify.getCart = async function () {
  let fetchUrl = window.Shopify.routes.root + 'cart.js';

  let response = await fetch(fetchUrl, {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
  });

  let cart = await response.json();

  return cart;
};

window.addEventListener('DOMContentLoaded', function () {
  // Hide Rewards Toggle
  setTimeout(() => {
    if (!window.jQuery('body').hasClass('hide-rewards')) {
      window.defer(() => {
        const targetNode = document.querySelector('.upez--inner-drawer-container');
        const config = { attributes: true, childList: true, subtree: false };
        const callback = (mutationList, observer) => {
          for (const mutation of mutationList) {
            console.log('Rewards toggle mutation');
            const cartIsOpen = $('.upez--inner-drawer-container').attr('cart-open');

            if (cartIsOpen == 'true' && !window.jQuery('body').hasClass('hide-rewards')) {
              window.jQuery('body').addClass('hide-rewards');
            }
          }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }, '#upezCart .upez--inner-drawer-container');
    }
  }, 1000);

  function addToCartFromForm($elem, additionalData = []) {
    let variantId =
      $elem.attr('data-variant-id') ??
      window.jQuery(".product-form__variants :input[name='id']").val();
    let variant = window.PDP.productData.variants.find(function (variant) {
      return +variant.id === +variantId;
    });

    let qty = $elem.attr('data-qty') ?? 1;
    let referrer = $elem.attr('data-referrer');
    let isSubscription = window.jQuery('[data-selector-subsave] input:checked').length > 0;
    let sellingPlan = isSubscription
      ? {
          name: window
            .jQuery('.subscription-options .rc_widget__option__selector input')
            .eq(0)
            .attr('name'),
          selectedValue: window.jQuery('.Product .rc_widget__option__plans__dropdown').eq(0).val(),
        }
      : {};
    if (
      referrer === 'scroll-subnav' &&
      !window.PDP.variantsInteracted &&
      window.jQuery('.shade-selector-modal__wrapper').length
    ) {
      window
        .jQuery('.shade-selector-modal__bg, .shade-selector-modal__wrapper')
        .toggleClass('visible', true);
      window.jQuery('html').toggleClass('no-scroll', true);
      window.jQuery('body').toggleClass('shade-selector-open', true);
      moveSecondarySubscriptionWidget();
    } else {
      if (referrer === 'shade-selector-modal') {
        window
          .jQuery('.shade-selector-modal__bg, .shade-selector-modal__wrapper')
          .toggleClass('visible', false);
        window.jQuery('html').toggleClass('no-scroll', false);
        window.jQuery('body').toggleClass('shade-selector-open', false);
      }

      return addToCartWithCartUpdate(variant, qty, isSubscription, sellingPlan, additionalData);
    }
  }

  function setHeaderHeightProperties() {
    const headerHeight = document.querySelector(
      '#section-medispa-header,#section-header',
    ).clientHeight;
    let secondaryNavHeight =
      window.outerWidth < 1008
        ? document.querySelector('.Search').clientHeight
        : document.querySelector('nav.Header__MainNav').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--secondary-nav-height', secondaryNavHeight + 'px');
  }

  window.jQuery(document).ready(function () {
    setHeaderHeightProperties();

    window.jQuery(window).on('resize', function () {
      setHeaderHeightProperties();
    });

    window.jQuery('.collection-description').click(function (event) {
      event.preventDefault();
      let Ele = window.jQuery(this);
      if (Ele.hasClass('inline')) {
        window.jQuery(this).removeClass('inline');
        window.jQuery(this).text('Read Less');
        window.jQuery('.SectionHeader__Description').removeClass('inline');
      } else {
        window.jQuery(this).addClass('inline');
        window.jQuery(this).text('Read More');
        window.jQuery('.SectionHeader__Description').addClass('inline');
      }
    });
  });

  function updateRecentProducts() {
    let isPDP = !!document.querySelector('body.template-product');

    if (!isPDP) return;

    let productHandle = window.location.pathname.split('/').pop();

    let existingEntries = localStorage.getItem('recently-viewed-products');

    existingEntries = existingEntries ? JSON.parse(existingEntries) : [];

    // Remove existing versions of this handle from the list
    existingEntries = existingEntries.filter(function (entry) {
      return entry !== productHandle;
    });

    existingEntries.unshift(productHandle);

    localStorage.setItem('recently-viewed-products', JSON.stringify(existingEntries));
  }

  window.jQuery('.medispa-dropdown-trigger').on('click', function () {
    window.jQuery(this).toggleClass('open');
    window.jQuery(this).closest('.booking-wrapper').toggleClass('open');
  });

  function rawAddToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    }).then((resp) => resp.json());
  }

  function addPromoLabels(items) {
    if (!!window?.theme?.packOptions?.labels?.cart_message) {
      items.forEach((item) => {
        // const unitPriceDollars = item.final_price / 100;
        // const priceThreshold = window?.theme?.gift_product?.price_threshold;
        if (item.quantity >= 3) {
          item.properties['Promotion'] = window.theme.packOptions.labels.cart_message;
        }
      });
    }

    return items;
  }

  function __addToCart(variant, quantity, isSubscription, sellingPlan, additionalData) {
    return new Promise(function (resolve, reject) {
      let payload = {
        form_type: 'product',
        utf8: '✓',
        items: [
          {
            properties: {
              _barcode: variant.sku,
            },
            id: variant.id,
            quantity: quantity,
          },
        ],
      };

      payload.items = addPromoLabels(payload.items);

      if (additionalData?.length) {
        payload.items.push(...additionalData);
      }

      const promotionLabel = additionalData?.find((item) => !!item?.properties?._promotion);

      if (promotionLabel) {
        payload.items[0].properties['_promotion'] = promotionLabel.properties._promotion;
        // window.clarity('set', 'promotion', promotionLabel.properties._promotion);
      }

      payload.items.forEach((item, idx) => {
        // window.clarity('set', `item_add_${idx}`, `${item.id}:${item.quantity}`);
      });

      // if (quantity >= window.theme.gift_product.required_amount) {
      //   payload.items[0].properties['_promotion'] = 'b3g3';
      // }

      payload[sellingPlan.name] = isSubscription ? 'subsave' : 'onetime';
      if (isSubscription) payload['selling_plan'] = sellingPlan.selectedValue;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((resp) => resp.json())
        .then(resolve)
        .catch(reject);
    });
  }

  function addToCartWithCartUpdate(variant, qty, isSubscription, sellingPlan, additionalData) {
    return new Promise(function (resolve, reject) {
      try {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        __addToCart(variant, qty, isSubscription, sellingPlan, additionalData)
          .then(function () {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variant.id,
                  quantity: qty,
                },
              }),
            );
          })
          .then(resolve)
          .catch(function (err) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            console.trace(err);
            console.error(err.statusText);

            reject(err.responseJSON.description);
          });
      } catch (e) {
        reject(e);
      }
    });
  }

  function clearSwatchFilters() {
    window.jQuery('label.ColorSwatch[data-category]').each(function (idx, elem) {
      window.jQuery(elem).closest('.js-variant').toggleClass('hidden', false);
    });
  }

  function syncQuantities(newQuantity, packMultiple = 1) {
    window.jQuery('.product-form__quantity input.product-form__quantity-input').val(newQuantity);
    window
      .jQuery(".product-form__add-to-cart[data-action='add-to-cart'][data-qty]")
      .attr('data-qty', newQuantity * packMultiple);
  }

  window.jQuery('.product-form__quantity-input').on('change', function () {
    let updatedVal = window.jQuery(this).val();

    syncQuantities(
      updatedVal,
      parseInt(
        document.querySelector('[data-bundle-option].active')?.getAttribute('data-pack-multiple') ||
          '1',
      ),
    );
  });

  function setSwatchFilter(group) {
    window.jQuery('label.ColorSwatch[data-category]').each(function (idx, elem) {
      let elemGroups = elem.dataset.category.split('$$');
      let matchesFilter = elemGroups.indexOf(group) !== -1;
      window.jQuery(elem).closest('.js-variant').toggleClass('hidden', !matchesFilter);
    });
  }
  window.jQuery('body').on('click', '.js-action', function (e) {
    let $elem = window.jQuery(this);
    let action = $elem.attr('data-action');

    if (!action) return;

    switch (action) {
      case 'open-modal': {
        e.preventDefault();
        let target = $elem.attr('data-target');
        let $target = window.jQuery(target);
        if (!$target.length) return;
        $target.toggleClass('visible', true);
        break;
      }
      case 'close-modal': {
        e.preventDefault();
        let target = $elem.attr('data-target');
        let $target = window.jQuery(target);
        if (!$target.length) return;
        $target.toggleClass('visible', false);
        window.jQuery('html').toggleClass('no-scroll', false);

        $target.find('video').trigger('pause');
        break;
      }
      case 'close-modal-self': {
        e.preventDefault();
        let $target = $elem;
        if (!$target.length) return;
        $target.toggleClass('visible', false);
        window.jQuery('html').toggleClass('no-scroll', false);

        $target.find('video').trigger('pause');
        break;
      }
      case 'toggle-tab': {
        let targetSelector = $elem.attr('data-target');
        let $scope = window.jQuery($elem.attr('data-scope')) || $elem.parent();
        $scope.find('.tab-header').each(function (idx, elem) {
          let $elem = window.jQuery(elem);
          $elem.toggleClass('active', false);
          let elemTarget = $elem.attr('data-target');
          window.jQuery(elemTarget).toggleClass('active', false);
        });
        let target = $scope.find(targetSelector);
        window.jQuery(this).toggleClass('active', true);
        target.toggleClass('active', true);
        let $parent = window.jQuery(this).parent();
        let parent = $parent.get(0);
        let activeItem = $parent.find('.active').get(0);
        let numTabs = $parent.find('.tab-header').length;
        let activeItemWidth =
          window.jQuery(activeItem).index() === numTabs - 1
            ? parent.getBoundingClientRect().width - activeItem.offsetLeft
            : activeItem.offsetLeft + activeItem.getBoundingClientRect().width;
        let activeleftOffset = window.jQuery(activeItem).index() === 0 ? 0 : activeItem.offsetLeft;
        parent.style.setProperty('--num-tabs', numTabs);
        parent.style.setProperty('--active-item-width', activeItemWidth);
        parent.style.setProperty('--active-item-left-offset', activeleftOffset);
        break;
      }
      case 'add-to-cart': {
        e.preventDefault();
        window.jQuery('body').addClass('hide-rewards');

        // Purchase 3 to get gift modal
        window.PurchaseGiftManager.showModal().then(async function ({ status }) {
          // const selectedPack = document.querySelector('[data-bundle-option].active');

          // let packGifts;

          // if (selectedPack) {
          //   const selectedPackGifts = JSON.parse(selectedPack.getAttribute('data-bundle-gifts'));

          //   const groupedGifts =
          //     await window.PurchaseGiftManager.sortGiftsByCartStatus(selectedPackGifts);

          //   packGifts = window.PurchaseGiftManager.createGiftsPayloads(groupedGifts);

          //   console.debug(packGifts);
          // }

          // let parsedGifts = await window.PurchaseGiftManager.parseCartGifts(),
          //   mergedGifts = await window.PurchaseGiftManager.parseCartGifts();

          // if (packGifts?.notInCart?.length) {
          //   mergedGifts.notInCart.payload.push(...packGifts.notInCart);
          // }

          // if (packGifts?.inCart) {
          //   mergedGifts.inCart.payload = deepmerge(parsedGifts.inCart.payload, packGifts.inCart);
          // }

          // console.debug('Parsed gifts', parsedGifts);
          // console.debug('Merged gifts', mergedGifts);

          if (status === 'user-rejected') {
            return addToCartFromForm($elem);
          }

          if (status === 'not-eligible') {
            return addToCartFromForm($elem);
          }

          if (status === 'not-needed') return addToCartFromForm($elem);

          if (status === 'add-multiple') {
            $elem.attr('data-qty', window.theme.gift_product.required_amount);
            return addToCartFromForm($elem);
          }
        });
        break;
      }
      case 'add-variant-to-cart': {
        let variantId = $elem.attr('data-variant-id');
        let qty = $elem.attr('data-qty') ?? 1;

        rawAddToCart(variantId, qty);
        window.jQuery('body').addClass('hide-rewards');

        break;
      }
      case 'change-swatch-group': {
        let group = $elem.attr('data-group');
        if (!group) clearSwatchFilters();
        else setSwatchFilter(group);
        $elem.siblings('.active').toggleClass('active', false);
        $elem.toggleClass('active', true);
        break;
      }
      case 'change-carousel-position': {
        // This has been moved into a variant:changed listener
        break;
      }
      case 'decrease-quantity':
      case 'increase-quantity': {
        let updatedVal = $elem.siblings('input.product-form__quantity-input').val();

        let packMultiple = parseInt(
          document
            .querySelector('[data-bundle-option].active')
            ?.getAttribute('data-pack-multiple') || '1',
        );

        if (isNaN(packMultiple)) {
          console.error('Could not find pack multiple element! Defaulting to 1');

          packMultiple = 1;
        }

        syncQuantities(updatedVal, packMultiple);
        break;
      }
      case 'open-calendar': {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Insert products fragment into config, then open calendar
        const fragmentContent = e.target
          .closest('.service-item')
          ?.querySelector("script[id^='medispa-products-fragment-']");

        if (fragmentContent) {
          console.debug('Fragment content:', fragmentContent);

          const products = JSON.parse(fragmentContent.textContent);

          console.debug('Products:', products);

          window.theme.medispaCalendarConfig.products = products;
          window.theme.medispaCalendarConfig.selectedProduct = products[0].id.toString();

          document.dispatchEvent(
            new CustomEvent('theme:medispaCalendarConfig', {
              detail: window.theme.medispaCalendarConfig,
            }),
          );
        }

        const mainCta = e.target.closest('[data-product-id]');

        if (!mainCta) return;

        console.debug('Opening calendar', mainCta);

        const productId = mainCta.getAttribute('data-product-id');
        if (!productId) return;

        window.theme.medispaCalendarConfig.selectedProduct = productId;

        document.dispatchEvent(
          new CustomEvent('theme:medispaCalendarConfig', {
            detail: window.theme.medispaCalendarConfig,
          }),
        );

        document.documentElement.classList.add('lock-scrolling');

        // Uncomment later for calendar rework
        const calendarElem = document.querySelector('.medispa-calendar--placeholder');
        if (!calendarElem) return;

        calendarElem.classList.add('active');

        break;
      }
      case 'open-call-modal': {
        window.jQuery('.generic-overlay-bg, .call-us-modal__wrapper').toggleClass('visible');
        break;
      }
      case 'watch-video': {
        e.preventDefault();

        let videoConfig = JSON.parse(decodeURIComponent($elem.data('videoConfig')));

        let sourcesHtml = videoConfig.sources
          .map(function (source) {
            if (!source.url || !source.mime_type) return '';

            return `<source src="${source.url}" type="${source.mime_type}">`;
          })
          .join('');

        let $existingPlayer = window.jQuery('.video-overlay__wrapper');

        if ($existingPlayer.length) {
          $existingPlayer.find('video source').remove();
          $existingPlayer.find('video').html(sourcesHtml);
          $existingPlayer.find('video').attr('width', videoConfig.sources[0].width);
          $existingPlayer.find('video').attr('height', videoConfig.sources[0].height);
        } else {
          $existingPlayer = window
            .jQuery(
              `<div class="video-overlay__wrapper">
          <video autoplay controls width="{{WIDTH}}" height="{{HEIGHT}}">
              {{SOURCES}}
              Your browser does not support the video tag.
          </video>
      </div>`
                .replace(/{{WIDTH}}/g, videoConfig.sources[0].width)
                .replace(/{{HEIGHT}}/g, videoConfig.sources[0].height)
                .replace(/{{SOURCES}}/g, sourcesHtml),
            )
            .appendTo('body');
        }

        $existingPlayer.css('--aspect-ratio', videoConfig.aspect_ratio);

        $existingPlayer.toggleClass('visible', true);
        window.jQuery('.generic-overlay-bg').toggleClass('visible', true);

        window.jQuery('.generic-overlay-bg').one('click', function () {
          window.jQuery('.generic-overlay-bg').toggleClass('visible', false);
          $existingPlayer.toggleClass('visible', false);
          $existingPlayer.find('video').get(0).pause();
        });

        break;
      }
      case 'add-required-to-cart': {
        e.preventDefault();

        return window.PurchaseGiftManager.addRequiredForGiftToCart($elem);
      }
      default: {
        console.debug('Unhandled JS event: ', action);
        break;
      }
    }
  });

  document.addEventListener('variant:changed', function (event) {
    console.debug(event);
    let variant = event.detail.variant; // Gives you access to the whole variant details
    window.jQuery('.product-form__quantity input.product-form__quantity-input').val(1);

    window.jQuery('.purchase-gift__hitpoint').attr('data-variant-id', variant.id);

    window
      .jQuery('.product-gift-modal__viewport .add-required-to-cart')
      .attr('data-variant-id', variant.id);

    window.PurchaseGiftManager.onVariantChange(variant);

    // Slide to new variant image
    const newFeaturedImageIndex = event.detail.variant.featured_image?.position;

    if (typeof newFeaturedImageIndex === 'number') {
      // Adjust index based on whether it is after the videoly carousel items
      let adjustedIndex = newFeaturedImageIndex;

      if (newFeaturedImageIndex > window.PDP.videolyOffset) {
        adjustedIndex = newFeaturedImageIndex + window.PDP.videolyOffset;
      }

      // console.debug(
      //   `Sliding to index ${adjustedIndex}. New featured image index: ${newFeaturedImageIndex}`,
      // );

      const thumbs = window.jQuery('.product-image-thumbs-wrapper');
      const main = window.jQuery('.product-main-carousel-wrapper');
      thumbs.get(0).swiper.slideTo(adjustedIndex - 1);
      main.get(0).swiper.slideTo(adjustedIndex - 1);
    }
  });

  updateRecentProducts();

  function moveSecondarySubscriptionWidget() {
    let isMobile = window.jQuery(window).outerWidth() < 960;

    if (isMobile && window.jQuery('.scroll-subnav .subscription-options').length) {
      window
        .jQuery('.scroll-subnav .subscription-options')
        .insertBefore(".ProductForm__AddToCart[data-referrer='shade-selector-modal']");
    } else if (
      !isMobile &&
      window.jQuery('.shade-selector-modal__wrapper .subscription-options').length
    ) {
      window
        .jQuery('.shade-selector-modal__wrapper .subscription-options')
        .insertBefore('.scroll-subnav .product-actions');
    }
  }

  window.jQuery(window).on('resize', moveSecondarySubscriptionWidget);

  // Emphasise BNDL code
  window.defer(function () {
    let widgetDescription = window.jQuery(
      '.widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description',
    );

    widgetDescription.html(
      widgetDescription.html().replace(/BNDL/g, "<strong class='bundle-code'>BNDL</strong>"),
    );
  }, '.widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description');

  window.deferJS(
    () => {
      setTimeout(() => {
        const atcSkeleton = document.querySelector(
          '.buttons.product-form__button .button-skeleton',
        );

        if (!atcSkeleton) return;

        atcSkeleton.classList.add('!hidden');
      }, 1000);
    },
    () => {
      return typeof klaviyo.init !== 'undefined';
    },
  );
});
